<dz-modal-header>
	<h1 class="dz-text-28-extra-bold" dcrHTMLKey="PARTNER_ACKNOWLEDGEMENT_UPDATED_TERMS_HEADER">Updated Terms and Conditions</h1>
</dz-modal-header>
<dz-modal-content>
	<ng-container *ngIf="!isSavingAcknowledgement">
		<div [dcrHTMLKey]="'PARTNER_ACKNOWLEDGEMENT_UPDATED_NOTIFICATION_MSG_' + selectedPartner?.id"></div>
		<div class="partner-acknowledgement-disclaimer-msg" [dcrHTMLKey]="'PARTNER_ACKNOWLEDGEMENT_DISCLAIMER_MSG_' + selectedPartner?.id"></div>
	</ng-container>
	<ng-container *ngIf="isSavingAcknowledgement">
		<div class="dz-flex dz-justify-content-center dz-align-items-center padding-horizontal-layout-7 partner-refresh-loader">
			<dz-progress-spinner></dz-progress-spinner>
			<p class="margin-top-layout-2" dcrHTMLKey="PARTNER_ACKNOWLEDGEMENT_LOADER_MSG">Please wait while we store your acknowledgement</p>
		</div>
	</ng-container>
</dz-modal-content>
<dz-modal-actions *ngIf="!isSavingAcknowledgement" class="dz-justify-content-between">
	<button dz-button color="secondary" (click)="onDecline()" dcrHTMLKey="PARTNER_PORTFOLIOS_ACKNOWLEDGEMENT_DECLINE">I Decline</button>
	<button dz-button (click)="storeUserAcknowledgement()" dcrHTMLKey="PARTNER_PORTFOLIOS_ACKNOWLEDGEMENT_ACCEPT">I Accept</button>
</dz-modal-actions>
